var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.hasSentryFeedback)?_c('VBtn',{staticClass:"sentry-feedback-btn",attrs:{"fab":"","color":"secondary","dark":"","fixed":"","bottom":"","right":"","aria-label":_vm.$t('feedback.actions.open').toString()},on:{"click":_vm.openDialog}},[_c('VIcon',[_vm._v("mdi-bug")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }